<template>
  <router-view />
</template>


<script>
import navigation from './components/Navigation'
import AppFooter from './components/Footer'
import home from './components/HomeSection'
import about from './components/AboutSection'
import pricing from './components/PricingSection'
import contact from './components/ContactSection'
import BlogSection from '@/components/BlogSection'
import CommentsSection from '@/components/CommentsSection'

export default {
  name: 'App',

  components: {
    CommentsSection,
    navigation,
    AppFooter,
    home,
    about,
    pricing,
    contact,
    BlogSection
  },

  data: () => ({
    fab: null,
    color: '',
    flat: null
  }),

  created() {
    this.$store.dispatch('fetchSiteData')

    const top = window.pageYOffset || 0
    if (top <= 60) {
      this.color = 'light-blue lighten-5'
      this.flat = false
    }
  },

  watch: {
    fab(value) {
      if (value) {
        this.color = 'light-blue lighten-5'
        this.flat = false
      } else {
        this.color = 'light-blue lighten-5'
        this.flat = false
      }
    }
  },

  methods: {
    onScroll(e) {
      if (typeof window === 'undefined') return
      const top = window.pageYOffset || e.target.scrollTop || 0
      this.fab = top > 60
    },
    toTop() {
      this.$vuetify.goTo(0)
    }
  }
}
</script>

<style>
b, strong {
  font-weight: bold !important;
}
.v-main {
	overflow-x: hidden;
}
.app-bar {
	z-index: 100 !important;
}
</style>